export const STORAGE_RATIO_TO_SHOW_BANNER = 0.9;
export const PACKAGE_NAME = 'jiraGrowthStorageLimits';
export const ERROR_BOUNDARY_ID = 'storageLimitsBanner';
export const ASYNC_ERROR_BOUNDARY_ID = 'asyncStorageLimitsBanner';
